// extracted by mini-css-extract-plugin
export default {"root_svg":"root_svg___gVMqu","pointer":"pointer___SyvFs","svg":"svg___DewzA"};